/**
 * Entity types that support file uploads in the storage system.
 * Used for organizing uploaded files by entity category.
 */
export var FileUploadEntityType;
(function (FileUploadEntityType) {
    FileUploadEntityType["TOKEN"] = "token";
    FileUploadEntityType["CAMPAIGN"] = "campaign";
    FileUploadEntityType["REDEMPTION"] = "redemption";
    FileUploadEntityType["BUSINESS"] = "business";
    FileUploadEntityType["TENANT"] = "tenant";
    FileUploadEntityType["USER"] = "user";
})(FileUploadEntityType || (FileUploadEntityType = {}));
//# sourceMappingURL=file-upload-entity-type.enum.js.map